import React from "react";
import { getColor } from '../utils/ColorMapper'
import { ActionTable } from "./ActionTable";
import MenuItem from '@mui/material/MenuItem';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import lodash from "lodash";
import { getCtrlSymbol, isMac } from "../utils/PlatformUtils";

export class CheckTable extends ActionTable {
	constructor(props) {
		super(props);
		this.arr = this.getInternalArr(this.props.data, true);
		this.state.data = this.arr;
		this.state.history = [lodash.cloneDeep(this.arr)];
		this.state.historyIndex = 0;
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	setSlot(event) {
		if (this.toggleOn === undefined) {
			return;
		}
		let row = this.getIndexFromX(this.getMouseX(event));
		let col = this.getIndexFromY(this.getMouseY(event));

		if (col >= 0 && col < this.arr.length && row >= 0 && row < this.arr[col].length && this.arr[col][row] !== this.toggleOn) {
			this.arr[col][row] = this.toggleOn;
			this.setState({data: this.arr});
		}
	}

	onTableDrag(event) {
		this.setSlot(event)
	}

	onTableRelease() {
		this.toggleOn = undefined;
	}

	initFn = (event) => {
		let row = this.getIndexFromX(this.getMouseX(event));
		let col = this.getIndexFromY(this.getMouseY(event));
		this.toggleOn = this.arr[col][row] ? false : true;
		this.setSlot(event);
	}

	tableActions() {
		return {onMouseDown: this.onRightMouseDown(this.initFn, this.onTableDrag, this.onTableRelease, this.onTableRelease), onMouseMove: this.onMouseMove, onMouseUp: this.onRightMouseUp };
	}

	handleKeyDown = (event) => {
		super.handleKeyDown(event);
		const ctrlKey = isMac() ? event.metaKey : event.ctrlKey;

		if (ctrlKey && !event.shiftKey && (event.key === 'a' || event.key === 'A')) {
			event.preventDefault();
			event.stopPropagation();
			this.setState({selectAll: !this.state.selectAll});
		}
	}

	additionalMenuItems() {
		return [<MenuItem key="selectAll" onClick={() => this.setState({selectAll: !this.state.selectAll})}>
			<ListItemIcon>
				{!this.state.selectAll ? <SelectAllIcon fontSize="small" /> : <DeselectIcon fontSize="small" />}
			</ListItemIcon>
			<ListItemText>{!this.state.selectAll ? "Select all" : "Deselect All" }</ListItemText>
			<Typography variant="body2" sx={{ color: 'text.secondary' }}>
				{getCtrlSymbol()}A
			</Typography>
		</MenuItem>];
	}

	render() {
		let table;
		if (this.state.selectAll) {
			table = <table className="selection" ref={this.tableRef} width={"100%"}>
				{ this.constructTableHeader() }
				<tbody>
					{this.props.tableRows.map((_, i) => {
						return <tr className="selection" key={i} height={this.props.height}>
							{ this.constructTableRowHeader(i) }
							{this.props.tableCols.map((_, j) => {
								return <td className="selection" key={j} style={{background: getColor(this.props.color, 200)}}></td>
							})}
						</tr>
					})}
				</tbody>
			</table>
		} else {
			this.state.data.splice(this.props.tableRows.length, this.state.data.length - this.props.tableRows.length);
			for (let i = this.state.data.length; i < this.props.tableRows.length; i += 1) {
				this.state.data.push([]);
			}

			table = <table className="selection" ref={this.tableRef} width={"100%"} {...this.tableActions()} >
				{ this.constructTableHeader() }
				{this.state.data.map((tableRow, i) => {
					return <tr className="selection" key={i} height={this.props.height}>
						{ this.constructTableRowHeader(i) }
						{tableRow.map((present, j) => {
							return <td className="selection" key={j} style={present ? {background: getColor(this.props.color, 500)} : undefined} />
						})}
					</tr>
				})}
			</table>
		}
		return super.render(table);
	}

	returnData = () => {
		let data = [];
		for (var i = 0; i < this.arr.length; i += 1) {
			let row = [];
			let start = undefined;
			for (var j = 0; j < this.arr[i].length; j += 1) {
				if (this.arr[i][j]) {
					if (start === undefined) {
						start = j;
					}
				} else {
					if (start !== undefined) {
						row.push([start, j]);
						start = undefined;
					}
				}
			}
			if (start !== undefined) {
				row.push([start, this.arr[i].length]);
			}
			data.push(row);
		}
		return [data, this.state.selectAll, this.state.clipboard];
	}

	getInternalArr(data, retain) {
		if (data === undefined || !retain) {
			data = [...Array(this.props.tableRows.length)].map(() => []);
		}
		let arr = new Array(this.props.tableRows.length)
		for (let i = 0; i < arr.length; i += 1) {
			arr[i] = new Array(this.props.tableCols.length).fill(undefined);
			if (data[i] === undefined) {
				continue;
			}
			for (let j = 0; j < data[i].length; j += 1) {
				for (let k = Math.max(data[i][j][0], 0); k < Math.min(data[i][j][1], this.props.tableCols.length); k += 1) {
					arr[i][k] = true;
				}
			}
		}
		return arr;
	}

	loadData = (data, selectAll, retain, clipboard, doNotResetCache) => {
		this.arr = this.getInternalArr(data, retain);
		if (!doNotResetCache) {
			this.setState({history: [lodash.cloneDeep(this.arr)], historyIndex: 0});
		} else {
			this.cacheData(this.arr);
		}
		this.setState({data: this.arr, selectAll: selectAll, clipboard: clipboard})
	}
}